var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"position":"relative"},attrs:{"colspan":"1"}},[_c('Avatar',{attrs:{"type":'icon',"size":'medium',"theme-color":_vm.color}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }